// src/pages/Utilitarios.js
import React from 'react';
import ExcelChart from '../Funciones/ExcelChart';
import "bootstrap/dist/css/bootstrap.min.css";
import PiesChart from '../Funciones/PiesChart';

const Utilitarios = () => 
<div>
    <div>
        <p className="m-2"><b>N°1</b> Gráfico de Lineas o Columnas</p>
        <div className="bg-light mx-auto px-2 border border-2 border-primary" style={{width:"1050px", height:"600px"}} >
          <div style={{width:"100%",height:"100%",padding:"1px 0"}}>
              <ExcelChart/>
          </div>
        </div>
    </div>
    <hr className="mt-3 mb-2"/>
     {/*---------------------------------------------------------------------------------------- */}
     <div>
        <p className="m-2"><b>N°2</b> Gráfico Circular</p>
        <div className="bg-light mx-auto px-2 border border-2 border-primary" style={{width:"1050px", height:"600px"}} >
          <div style={{width:"100%",height:"100%",padding:"1px 0"}}>
              <PiesChart/>
          </div>
        </div>
    </div>
    <hr className="mt-3 mb-2"/>
     {/*---------------------------------------------------------------------------------------- */}
</div>;
export default Utilitarios;